export const contrats = {
  form: {
    document: "Document",
    nb: "Number of recipients",
    status: "Status",
    createdAt: "Creation date",
    certification: "Certificate",
    title_edit: "View contract",
  },
  actions: {
    edit: "View",
  },
  header_title: "Contract list",
};
